import { defineMessages } from "react-intl";

const messages = defineMessages({
    upload:{
	id: "app.upload-admin-console.uploadText",
	description: "upload text",
	defaultMessage: "UPLOAD"
    },

    uploadError:{
	id: "app.upload-admin-console.uploadFileError",
	description: "upload error",
	defaultMessage: "You can only upload JPEG, JPG, PNG, PDF, DOC, DOCX file!"
    }
});

export default messages;
